// BrandsDemo.jsx
import React from "react";
import LogoSlider from "../component/Brands/LogoSlider";
import "./Home/Home.css"
// importe tes images locales (exemples) :
import ford from "../images/cars/ford.png";
import fiat from "../images/cars/fiat.png";
import porsche from "../images/cars/porsche.png";
import bmw from "../images/cars/bmw.png";
import tesla from "../images/cars/tesla.png";
import lamborghini from "../images/cars/lamborghini.png";
import ferrari from "../images/cars/ferrari.png";
import mercedes from "../images/cars/mercedes.png";
import peugeot from "../images/cars/peugeot.png";
import { useBrand } from "../context/brand-context";
export default function BrandsDemo(){
  const { brand } = useBrand(); // Récupération de la marque actuelle
  const isAmen = brand === "amen";
  // Rouge pour Amen (#BF2A37), Bleu pour MG (#2563eb)
  const underlineColor = isAmen ? "#7a0f18" : "#2563eb";
  const items = [
    { id: "ford",        name: "Ford",        src: ford },
    { id: "fiat",        name: "Fiat",        src: fiat },
    { id: "porsche",     name: "Porsche",     src: porsche },
    { id: "bmw",         name: "BMW",         src: bmw },
    { id: "tesla",       name: "Tesla",       src: tesla },
    { id: "lamborghini", name: "Lamborghini", src: lamborghini },
    { id: "ferrari",     name: "Ferrari",     src: ferrari },
    { id: "mercedes",    name: "Mercedes",    src: mercedes },
    { id: "peugeot",     name: "Peugeot",     src: peugeot },
  ];

  return (
    <section className="brands-demo-section">
      <div className="section-header">
        <h2 className="section-title">NOS MARQUES</h2>
        <div 
          className="section-underline" 
          style={{ backgroundColor: underlineColor }}
        ></div>
      </div>

      <LogoSlider logos={items} speed={40} cardWidth={200} />
    </section>
  );
}
